export default "__VITE_ASSET__Pu7Tww0f__"